// interface AudioTranscript {
// 	audio_file_path: string | null;
// 	audio_transcript: string;
// 	question: string;
// 	score: string | null; // Assuming it's a JSON string or null
// 	justification: string | null;
// }

import CustomAudioPlayer from "../BehaviouralTest/CustomAudioPlayer";

const CandidateBehaviouralScore = ({ transcripts }: any) => {
	if (!transcripts || transcripts.length === 0) {
		return <div>No audio transcripts available</div>;
	}
	return (
		<>
			<h2 className="text-xl  text-gray-800 dark:text-white font-subheading">
				Behavioural Response
			</h2>

			{transcripts.map((item: any, index: number) => {
				const behaviouralScore =
					typeof item.score === "string" ? JSON.parse(item.score) : item.score;
				return (
					<div key={index} className="my-2 font-body">
						<div className="ml-2">
							{/* Question Section */}
							<div>
								<h3 className=" font-medium ">
									<p className="inline-block text-lg">{index + 1}.</p>{" "}
									{item.question}
								</h3>
							</div>
							<div>
								<p className="text-gray-600 my-2 px-2">
									{item.audio_transcript}
								</p>
							</div>

							{/* Audio Section */}
							{item.audio_file_path && (
								// <div className="flex items-center mx-2  bg-gray-100 p-1 rounded-lg shadow-md ">
								// 	{/* Audio Icon */}

								// 	{/* Audio Player */}
								// 	<audio
								// 		controls
								// 		className="w-full bg-transparent focus:outline-none"
								// 		style={{
								// 			borderRadius: "8px",
								// 			overflow: "hidden",
								// 		}}
								// 	>
								// 		<source src={item.audio_file_path} type="audio/wav" />
								// 		Your browser does not support the audio element.
								// 	</audio>
								// </div>
								<CustomAudioPlayer url={item.audio_file_path} />
							)}
						</div>

						<h3 className="font-medium mt-4 mb-2 font-subheading text-lg">
							Overall Scores:
						</h3>
						{behaviouralScore ? (
							<>
								<div className="flex justify-center overflow-x-auto shadow-xl rounded-md">
									<table className="w-full border-collapse border  text-sm">
										<thead className="font-subheading">
											<tr className="bg-gray-100">
												<th className="p-3 border-r text-left">Metric</th>
												<th className="p-3  text-left">Result</th>
											</tr>
										</thead>
										<tbody className="font-body">
											{Object.entries(behaviouralScore.scores).map(
												([key, value]) => (
													<tr key={key}>
														<td className="p-3 border-r">
															{key
																.replace(/_/g, " ") // Replace underscores with spaces
																.toLowerCase() // Convert to lowercase
																.replace(/^\w/, (c) => c.toUpperCase())}
														</td>
														<td className="p-3 ">{value as React.ReactNode}</td>
													</tr>
												)
											)}
											<tr className="bg-gray-100">
												<td className="p-3 border-r font-bold">Total Score</td>
												<td className="p-3 font-bold">
													{behaviouralScore.final_score}
												</td>
											</tr>
										</tbody>
									</table>
								</div>
								<div className="text-gray-700 my-4">
									<div className="font-bold">Evaluation Remarks</div>
									<p className="m-2 ">{behaviouralScore.justification}</p>
								</div>
							</>
						) : (
							<div>No scores available</div>
						)}
					</div>
				);
			})}
		</>
	);
};

export default CandidateBehaviouralScore;
